<div class="sir-hero-media" [class.has-mobile-media]="hasMobileMedia()">
    @if (backgroundImageMobile(); as mobileBackground) {
        <sirius-image-item
            [image]="mobileBackground"
            [imageData]="imageData"
            objectFit="cover"
            objectPosition="center center"
            class="sir-image-mobile"
        />
    }
    @if (backgroundImage(); as desktopBackground) {
        <sirius-image-item
            [image]="desktopBackground"
            [imageData]="imageData"
            objectFit="cover"
            objectPosition="center center"
            class="sir-image-desktop"
        />
    }
    @if (backgroundVideoUrl(); as videoUrl) {
        <video
            #videoElement
            class="sir-hero-video"
            [class.is-show-mobile]="showVideoOnMobile()"
            [src]="videoUrl"
            [poster]="videoPosterUrl()"
            muted
            playsinline
            loop
            aria-hidden="true"
        ></video>
    }
</div>
<sirius-container>
    <div class="sir-hero-content sir-text-context-on-dark" [class.is-center]="contentAlignment() === 'center'">
        @if (eyebrow(); as eyebrowText) {
            <span class="sir-hero-eyebrow sir-text-style-paragraph-m-bold">
                {{ eyebrowText }}
            </span>
        }
        @if (title(); as titleText) {
            <sirius-heading
                class="sir-title"
                [text]="titleText"
                textStyleCategory="title"
                [textStyleSize]="titleSize()"
            >
            </sirius-heading>
        }
        @if (subTitle(); as subtitleText) {
            <p class="sir-hero-subtitle sir-text-style-paragraph-m-default">
                {{ subtitleText }}
            </p>
        }
        @if (hasCta()) {
            <div class="sir-hero-actions">
                @if (buttonPrimary(); as primaryButton) {
                    <a
                        siriusButton
                        [siriusLink]="primaryButton.link"
                        [iconName]="primaryButton.iconName"
                        [buttonText]="primaryButton.link.title"
                        buttonType="primary"
                        size="medium"
                    ></a>
                }
                @if (buttonSecondary(); as secondaryButton) {
                    <a
                        siriusButton
                        [siriusLink]="secondaryButton.link"
                        [iconName]="secondaryButton.iconName"
                        [buttonText]="secondaryButton.link.title"
                        buttonType="secondary"
                        size="medium"
                    ></a>
                }
            </div>
        }
    </div>
</sirius-container>
